<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003605.installation.desinfection.titre' | translate"
      [description]="
        'P0003605.installation.desinfection.description' | translate
      "
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P0003605.installation.regulation' | translate"
      [titleListe]="'P0003605.installation.regulation.redox' | translate"
      [value]="actionStack!.getValue('icPConsigneRegulationRx')"
      [liste]="P0003605ConsigneRegulationRxEnum"
      [information]="P0003605ESPInstallationCl"
      (onPress)="
        actionStack!.editValue(
          P00039DataRxTxIndex.InjectionChlore_Parametrage,
          'icPConsigneRegulationRx',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [titleListe]="'P0003605.configuration.hyteresis' | translate"
      [value]="actionStack!.getValue('icPHysteresisRegulationRx')"
      [liste]="P0003605HysteresisRegulationRx"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionChlore_Parametrage,
          'icPHysteresisRegulationRx',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (
      hasProduitP0003600() > 0 ||
      hasProduitP0003601() > 0 ||
      hasProduitP0004700() > 0 ||
      hasProduitP00046() > 0
    ) {
      <app-switch-configuration
        [nameCustom]="'P0003605.installation.filtration.value' | translate"
        [value]="
          actionStack!.getValue('icIActivationFonctionAutoMaintien') !== 0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.InjectionChlore_Installation,
            'icIActivationFonctionAutoMaintien',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>
    }

    <app-label-description
      [description]="'P0003605.installation.regulation.description' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
